import { OptionType } from '@bakbak/common';
import { Tag } from 'antd';
import * as React from 'react';
import { THEME_COLOR } from '../../constants';

interface Props {
  options: OptionType[];
  updateOptions: (options: string[]) => void;
  selectedOptions: string[] | null;
  optionDesignType: string;
  multiSelect: boolean;
}

export class OptionsComponent extends React.PureComponent<Props> {
  // componentDidUpdate() {
  //   // Update state only if props from parent are different from internal state
  //   if (this.props.selectedOptions && this.props.selectedOptions !== this.state.selectedOptions && this.props.selectedOptions.length !== 0) {
  //     this.setState({ selectedOptions: this.props.selectedOptions });
  //   }
  // }
  // UNSAFE_componentWillReceiveProps(nextProps: Props){
  //    // Update state only if props from parent are different from internal state
  //    if (this.props.selectedOptions && this.props.selectedOptions !== nextProps.selectedOptions && this.props.selectedOptions.length !== 0) {
  //     this.setState({ selectedOptions: this.props.selectedOptions });
  //   }
  // }
  updateOptions = (option: string) => {
    let updatedOptions = this.props.selectedOptions;
    if (updatedOptions === null) {
      updatedOptions = [option];
    } else {
      const foundIndex = updatedOptions.findIndex((stateOption: string) => stateOption === option);

      if (option === "All" || updatedOptions.findIndex(stateOption => stateOption === "All") !== -1) {
        updatedOptions = [option];
      }
      // Option value exists and if there is more than 1 selected element -> remove that value from the list
      else if (foundIndex !== -1 && updatedOptions.length > 1) {
        // updatedOptions.slice(foundIndex, 1);
        updatedOptions = [...updatedOptions.slice(0, foundIndex), ...updatedOptions.slice(foundIndex + 1)];
      }
      else {
        // Option name does not exist. Just add the name and value into the list.
        if (this.props.multiSelect) {
          updatedOptions = [...updatedOptions, option];
        }
        // Option name does not exist. Replace the value with whole list.      
        else {
          updatedOptions = [option];
        }
      }
    }
    this.props.updateOptions([...updatedOptions]);
  }

  render() {
    const { options, optionDesignType } = this.props;
    return options.map((option: OptionType) => {
      let headerStyle = styles.tagStyle;
      const { selectedOptions } = this.props;

      if (selectedOptions && selectedOptions.find((stateOption: string) => stateOption === option.value)) {
        headerStyle = styles.tagSelectedStyle;
      }

      if (optionDesignType === "tag") {
        return (
          <Tag key={option.name} style={headerStyle} onClick={() => this.updateOptions(option.value)}>
            {option.name}
          </Tag>
        );
      }
      else {
        return (
          <Tag key={option.name} style={headerStyle} onClick={() => this.updateOptions(option.value)}>
            {option.name}
          </Tag>
        );
      }
    })
  }
}

const styles = {
  tagSelectedStyle: {
    backgroundColor: 'white',
    color: THEME_COLOR,
    borderColor: THEME_COLOR,
    marginBottom: 10,
  },
  tagStyle: {
    backgroundColor: "white",
    color: "grey",
    marginBottom: 10,
  },
  panelStyle: {
    background: '#fff',
    borderRadius: 0,
    overflow: 'hidden',
  }
};



// WEBPACK FOOTER //
// ./src/modules/layout/OptionsComponent.tsx